import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Branchen() {
  return (
    <>
      <Helmet>
        <title>Branchen Social Recruiting Berlin | IT, Logistik, Gastronomie | famefact</title>
        <meta name="description" content="Social Recruiting für verschiedene Branchen in Berlin: IT & Technology, Logistik & Handel, Gastronomie, Start-ups. ✓ Branchenspezifische Strategien ✓ Seit 2009 ✓ Kostenloses Erstgespräch" />
        <meta name="keywords" content="Branchen Social Recruiting Berlin, IT Recruiting Berlin, Logistik Recruiting, Gastronomie Personalgewinnung, Start-up Recruiting" />
        <link rel="canonical" href="https://social-recruiting-berlin.de/branchen/" />
      </Helmet>

      <main id="main-content" role="main">
        {/* Hero Section */}
        <section className="hero hero--small">
          <div className="container">
            <div className="hero__content">
              <div className="hero__text">
                <h1 className="hero__title">
                  Branchen <span className="hero__highlight">Social Recruiting Berlin</span>
                </h1>
                <p className="hero__subtitle">
                  Branchenspezifische Social Recruiting Strategien für Berliner Unternehmen.
                  Von IT über Logistik bis Gastronomie – maßgeschneiderte Lösungen seit 2009.
                </p>
                <div className="hero__cta">
                  <a href="#" className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">
                    Kostenloses Erstgespräch
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="content-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Social Recruiting für alle Branchen in Berlin</h2>
              <p className="section-subtitle">
                Jede Branche hat ihre eigenen Anforderungen und Zielgruppen. Bei famefact
                entwickeln wir branchenspezifische Social Recruiting Strategien, die
                optimal auf Ihre Bedürfnisse zugeschnitten sind.
              </p>
            </div>

            {/* Industries Grid */}
            <div className="services-grid">
              {/* IT & Technology */}
              <div className="service-detail">
                <div className="service-detail__header">
                  <div className="service-detail__icon">
                    <svg className="icon" viewBox="0 0 24 24">
                      <path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>
                    </svg>
                  </div>
                  <h3 className="service-detail__title">IT & Technology</h3>
                </div>
                <p className="service-detail__description">
                  Die IT-Branche in Berlin boomt. Von Start-ups bis zu Großunternehmen
                  – wir finden die besten Tech-Talente über LinkedIn, Instagram und
                  spezialisierte Communities.
                </p>
                <div className="service-detail__features">
                  <h4>IT-Recruiting umfasst:</h4>
                  <ul>
                    <li>Entwickler, Designer und Product Manager</li>
                    <li>LinkedIn für professionelle Netzwerke</li>
                    <li>GitHub und Tech-Communities</li>
                    <li>Instagram für junge Talente</li>
                    <li>Branchenspezifische Events und Meetups</li>
                  </ul>
                </div>
                <Link to="/branchen/it-tech" className="btn btn--primary">
                  IT & Tech Recruiting Details
                </Link>
              </div>

              {/* Logistik & Handel */}
              <div className="service-detail">
                <div className="service-detail__header">
                  <div className="service-detail__icon">
                    <svg className="icon" viewBox="0 0 24 24">
                      <path d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm1.5-9H17V12h4.46L19.5 9.5zM6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3zM3 6v9h.76c.55-.61 1.35-1 2.24-1 .89 0 1.69.39 2.24 1H15V6H3z"/>
                    </svg>
                  </div>
                  <h3 className="service-detail__title">Logistik & Handel</h3>
                </div>
                <p className="service-detail__description">
                  Logistik und Handel sind tragende Säulen der Berliner Wirtschaft.
                  Wir erreichen Lagerarbeiter, Verkäufer und Führungskräfte über
                  gezielte Social Media Kampagnen.
                </p>
                <div className="service-detail__features">
                  <h4>Logistik-Recruiting beinhaltet:</h4>
                  <ul>
                    <li>Lager- und Transportpersonal</li>
                    <li>Verkaufs- und Führungskräfte</li>
                    <li>Facebook und Instagram für breite Reichweite</li>
                    <li>Lokale Gruppen und Netzwerke</li>
                    <li>Branchenspezifische Jobbörsen-Integration</li>
                  </ul>
                </div>
                <Link to="/branchen/logistik-handel" className="btn btn--primary">
                  Logistik Recruiting Details
                </Link>
              </div>

              {/* Gastronomie */}
              <div className="service-detail">
                <div className="service-detail__header">
                  <div className="service-detail__icon">
                    <svg className="icon" viewBox="0 0 24 24">
                      <path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/>
                    </svg>
                  </div>
                  <h3 className="service-detail__title">Gastronomie</h3>
                </div>
                <p className="service-detail__description">
                  Die Gastronomie-Szene in Berlin ist lebendig und vielfältig. Wir
                  finden Köche, Servicekräfte und Manager über authentische Inhalte
                  und lokale Netzwerke.
                </p>
                <div className="service-detail__features">
                  <h4>Gastronomie-Recruiting umfasst:</h4>
                  <ul>
                    <li>Köche, Servicekräfte und Manager</li>
                    <li>Instagram und TikTok für visuelle Ansprache</li>
                    <li>Lokale Facebook-Gruppen</li>
                    <li>Behind-the-Scenes Content</li>
                    <li>Events und Jobmessen</li>
                  </ul>
                </div>
                <Link to="/branchen/gastronomie" className="btn btn--primary">
                  Gastronomie Recruiting Details
                </Link>
              </div>

              {/* Start-ups */}
              <div className="service-detail">
                <div className="service-detail__header">
                  <div className="service-detail__icon">
                    <svg className="icon" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  </div>
                  <h3 className="service-detail__title">Start-ups</h3>
                </div>
                <p className="service-detail__description">
                  Berlin ist die Start-up-Hauptstadt Europas. Wir unterstützen
                  Start-ups bei der Gewinnung von Talenten über innovative und
                  kreative Social Media Strategien.
                </p>
                <div className="service-detail__features">
                  <h4>Start-up-Recruiting beinhaltet:</h4>
                  <ul>
                    <li>Junge Talente und Innovatoren</li>
                    <li>TikTok und Instagram für Gen Z</li>
                    <li>LinkedIn für erfahrene Professionals</li>
                    <li>Start-up-Communities und Events</li>
                    <li>Employer Branding für Wachstum</li>
                  </ul>
                </div>
                <Link to="/branchen/startups" className="btn btn--primary">
                  Start-up Recruiting Details
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Success Factors Section */}
        <section className="content-section" style={{ backgroundColor: '#f8f9fa' }}>
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Erfolgsfaktoren für branchenspezifisches Recruiting in Berlin</h2>
              <p className="section-subtitle">
                Jede Branche hat ihre Eigenheiten. Erfolgreiches branchenspezifisches
                Recruiting erfordert tiefes Branchenwissen und lokale Expertise.
              </p>
            </div>

            <div className="features-grid">
              <div className="feature-card">
                <h3>Branchenwissen</h3>
                <p>Verständnis der spezifischen Bedürfnisse und Anforderungen Ihrer Branche</p>
              </div>
              <div className="feature-card">
                <h3>Zielgruppen-Targeting</h3>
                <p>Präzise Ansprache der richtigen Kandidaten mit maßgeschneiderten Botschaften</p>
              </div>
              <div className="feature-card">
                <h3>Content-Anpassung</h3>
                <p>Branchenrelevante Inhalte und Formate, die Ihre Zielgruppe ansprechen</p>
              </div>
              <div className="feature-card">
                <h3>Netzwerk-Pflege</h3>
                <p>Aktive Beteiligung in Branchen-Communities und Fachgruppen</p>
              </div>
              <div className="feature-card">
                <h3>Performance-Optimierung</h3>
                <p>Kontinuierliche Anpassung der Strategie basierend auf Daten und Ergebnissen</p>
              </div>
              <div className="feature-card">
                <h3>Lokale Expertise</h3>
                <p>Tiefes Verständnis des Berliner Arbeitsmarkts und regionaler Besonderheiten</p>
              </div>
            </div>
          </div>
        </section>

        {/* Case Studies Section */}
        <section className="content-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Branchenspezifische Erfolge in Berlin</h2>
              <p className="section-subtitle">
                Bei famefact haben wir erfolgreiche Kampagnen für verschiedene Branchen durchgeführt
              </p>
            </div>

            <div className="case-studies">
              <div className="case-study-card">
                <h3>IT-Unternehmen in Berlin-Mitte</h3>
                <p>
                  Ein Software-Unternehmen suchte Entwickler. Durch LinkedIn
                  und GitHub-Integration fanden wir 20 qualifizierte Kandidaten
                  in 3 Wochen.
                </p>
                <div className="case-study-stats">
                  <div className="stat">
                    <div className="stat-number">20</div>
                    <div className="stat-label">Kandidaten</div>
                  </div>
                  <div className="stat">
                    <div className="stat-number">3</div>
                    <div className="stat-label">Wochen</div>
                  </div>
                </div>
              </div>

              <div className="case-study-card">
                <h3>Logistikfirma in Spandau</h3>
                <p>
                  Eine Logistikfirma benötigte Lagerarbeiter. Mit Facebook
                  Ads und lokalen Gruppen erreichten wir 30 Bewerbungen in
                  2 Wochen.
                </p>
                <div className="case-study-stats">
                  <div className="stat">
                    <div className="stat-number">30</div>
                    <div className="stat-label">Bewerbungen</div>
                  </div>
                  <div className="stat">
                    <div className="stat-number">2</div>
                    <div className="stat-label">Wochen</div>
                  </div>
                </div>
              </div>

              <div className="case-study-card">
                <h3>Restaurant in Prenzlauer Berg</h3>
                <p>
                  Ein Restaurant suchte Köche. Durch Instagram Stories und
                  lokale Netzwerke generierten wir 15 Bewerbungen in 10 Tagen.
                </p>
                <div className="case-study-stats">
                  <div className="stat">
                    <div className="stat-number">15</div>
                    <div className="stat-label">Bewerbungen</div>
                  </div>
                  <div className="stat">
                    <div className="stat-number">10</div>
                    <div className="stat-label">Tage</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Comparison Table Section */}
        <section className="content-section" style={{ backgroundColor: '#f8f9fa' }}>
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Branchenspezifisches vs. Generisches Recruiting</h2>
              <p className="section-subtitle">
                Im Vergleich zu generischen Methoden bietet branchenspezifisches Recruiting klare Vorteile
              </p>
            </div>

            <div className="comparison-table-wrapper">
              <table className="comparison-table">
                <thead>
                  <tr>
                    <th>Ansatz</th>
                    <th>Kosten</th>
                    <th>Qualität</th>
                    <th>Geschwindigkeit</th>
                    <th>Relevanz</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Generisch</td>
                    <td>Mittel</td>
                    <td>Mittel</td>
                    <td>Langsam</td>
                    <td>Niedrig</td>
                  </tr>
                  <tr className="highlight-row">
                    <td><strong>Branchenspezifisch</strong></td>
                    <td><strong>Niedrig</strong></td>
                    <td><strong>Sehr hoch</strong></td>
                    <td><strong>Schnell</strong></td>
                    <td><strong>Sehr hoch</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">FAQ: Branchen Social Recruiting Berlin</h2>
            </div>
            <div className="faq__content">
              <div itemScope itemType="https://schema.org/FAQPage">
                <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 itemProp="name">Welche Branchen unterstützen Sie?</h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p itemProp="text">
                      Wir unterstützen alle Branchen: IT & Technology, Logistik & Handel, Gastronomie,
                      Start-ups, Healthcare und mehr. Unsere branchenspezifischen Strategien sind auf die
                      jeweiligen Anforderungen und Zielgruppen zugeschnitten.
                    </p>
                  </div>
                </div>

                <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 itemProp="name">Wie passen Sie die Strategie an?</h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p itemProp="text">
                      Durch umfassende Branchenanalyse, Zielgruppen-Definition und Content-Anpassung
                      an branchenspezifische Bedürfnisse. Wir nutzen die optimalen Plattformen und
                      Ansprache-Methoden für Ihre spezifische Branche.
                    </p>
                  </div>
                </div>

                <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 itemProp="name">Was kostet branchenspezifisches Recruiting?</h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p itemProp="text">
                      Die Kosten liegen zwischen 8-25€ pro Bewerbung, abhängig von Branche und Position.
                      IT-Positionen liegen typischerweise im oberen Bereich, während Gastronomie und
                      Logistik im unteren Bereich angesiedelt sind.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2 className="cta-title">Bereit für branchenspezifisches Recruiting in Berlin?</h2>
              <p className="cta-subtitle">
                Vereinbaren Sie Ihre kostenlose Analyse für eine branchenspezifische Strategie,
                die perfekt auf Ihr Unternehmen zugeschnitten ist.
              </p>
              <div className="cta-buttons">
                <a href="#" className="btn btn--primary btn--large" data-open-consultation data-source="CTA Section">
                  Kostenloses Erstgespräch
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Branchen;
